<template>
  <el-table :data="tableData" style="width: 100%">
    <el-table-column
      v-for="col in columns"
      :key="col.prop || col.label"
      :label="col.label"
      :prop="col.prop"
      :width="col.width"
    >
      <template slot-scope="scope">
        <!-- 具名作用域插槽：如果配置了 slotName，优先使用外部传入的插槽内容 -->
        <slot v-if="col.slotName" :name="col.slotName" :row="scope.row"></slot>
        
        <template v-else>
          <!-- 操作列 -->
          <template v-if="col.type === 'action'">
            <el-button
              v-for="btn in col.actions"
              :key="btn.label"
              size="small"
              type="text"
              @click="btn.action(scope.row)"
            >
              {{ btn.label }}
            </el-button>
          </template>
          
          <!-- 普通文本列 -->
          <span v-else>{{ scope.row[col.prop] }}</span>
        </template>
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
export default {
  name: "CommonTable",
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    }
  }
};
</script>

<style scoped lang="scss">
</style>

<style lang="scss">
.el-image-viewer__wrapper {
  .el-image-viewer__canvas {
    .el-image-viewer__img {
      margin: auto !important;
    }
  }
}
</style>
